import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import DeltaIndicator from './DeltaIndicator';

// Middle card in Asset Health. Average asset availability % across the
// selected scope. Per V1 scope the delta is shown if the backend already
// surfaces availabilityChange (per-org case); for the global rollup it is
// intentionally null today and renders silent.

export default function AvailabilityCard({ data }) {
  const { t } = useTranslation();
  const pct = data?.availabilityPercentage;
  const delta = data?.availabilityChange;

  return (
    <Card className="h-100">
      <CardBody>
        <div className="fw-semibold mb-3">
          {t('shared.global_org.overview.availability_title', 'Availability Over Time')}
        </div>
        <div className="d-flex align-items-center gap-2">
          <div className="font-size-28 fw-bold">
            {pct == null ? '—' : `${Number(pct).toFixed(1)}%`}
          </div>
          <DeltaIndicator delta={delta} betterIsUp />
        </div>
        <div className="text-muted font-size-12 mt-1">
          {t('shared.global_org.overview.availability_subtitle', 'Average asset availability')}
        </div>
      </CardBody>
    </Card>
  );
}
